// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkWrapper_root__AV34E","disabled":"LinkWrapper_disabled__8ivaf"};